export type TimerState = {
  isTimerEnabled: boolean;
  allRoundsCompleted: boolean;
  completedTimers: string[];
};

export const initialTimerState: TimerState = {
  isTimerEnabled: true,
  allRoundsCompleted: false,
  completedTimers: [],
};

export type TimerAction =
  | { type: 'SET_TIMER_ENABLED'; payload: boolean }
  | { type: 'TOGGLE_TIMER_ENABLED' }
  | { type: 'SET_TIMER_WORK_ROUNDS_COMPLETED'; payload: { timerId: string } }
  | { type: 'RESET_TIMER_COMPLETIONS' };

export const timerReducer = (state: TimerState, action: TimerAction): TimerState => {
  switch (action.type) {
    case 'SET_TIMER_ENABLED':
      return {
        ...state,
        isTimerEnabled: action.payload,
      };
    case 'TOGGLE_TIMER_ENABLED':
      return {
        ...state,
        isTimerEnabled: !state.isTimerEnabled,
      };
    case 'SET_TIMER_WORK_ROUNDS_COMPLETED': {
      const completedTimers = state.completedTimers.includes(action.payload.timerId)
        ? state.completedTimers
        : [...state.completedTimers, action.payload.timerId];
      return {
        ...state,
        completedTimers,
        allRoundsCompleted: true, // Set to true when any timer completes its work rounds
      };
    }
    case 'RESET_TIMER_COMPLETIONS':
      return {
        ...state,
        completedTimers: [],
        allRoundsCompleted: false,
      };
    default:
      return state;
  }
};
